import { CollapseInterface } from "../../../Interfaces/CollapseInterface";
import { Icon } from "../../Elements";

const Collapse = ({
  onClick,
  keyItem,
  title,
  className,
  element,
  icon,
  index,
  classNameOnSelected,
}: CollapseInterface) => {
  return (
    <>
      <div className="flex flex-col justify-center items-center w-full  ">
        <div
          onClick={() => {
            onClick?.(keyItem);
          }}
          className={`  ${className?.className ?? ""
            }  flex justify-between items-center  relative p-2 bg-primary w-full transition-all
            cursor-pointer duration-200
           ${index
              ? classNameOnSelected ||
              "!bg-secondary !text-white rounded-b-2xl"
              : ""
            }`}
        >
          <div className="flex gap-1 justify-center items-center">
            <Icon
              icon={icon}
              className={` text-xl ${index ? "!text-white" : ""}   ${className?.iconClass ?? ""
                }`}
            />
            <span
              className={`${className?.titleClass ?? ""} ${index ? "!text-white" : ""
                }`}
            >
              {title}
            </span>
          </div>

          <Icon
            icon={"rayteb-arrow-1-down"}
            className={` text-xs  ${index ? "duration-300 rotate-180" : "duration-300 rotate-0"
              }`}
          />
        </div>
        <div className={`   w-full ${index ? "block" : "hidden"}`}>
          {element}
        </div>
      </div>
    </>
  );
};

export default Collapse;
